/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./adm.vue?vue&type=template&id=0b229d5c&scoped=true"
import script from "./adm.vue?vue&type=script&lang=js"
export * from "./adm.vue?vue&type=script&lang=js"
import style0 from "./adm.vue?vue&type=style&index=0&id=0b229d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b229d5c",
  null
  
)

export default component.exports